<mat-card style="margin-top: 30px">
  <mat-card-header>
    <h2 mat-card-title><mat-icon>analytics</mat-icon>Migration details</h2>
    <!-- <div>
      <button mat-button>
        <mat-icon>chevron_left</mat-icon>Back to migrations
      </button>
    </div> -->
  </mat-card-header>
  <mat-card-content class="main-mat-card-content">
    <app-progress-tracker
      [progress]="migration?.progressPercentage"
      [status]="migration?.status"
      [label]="migration?.company_name"
      [extraLabel]="migration?.status"
      [extraBottomLeftLabel]="migration?.statusLabel"
      [tooltipText]="getTooltipText()"
      [showPercentage]="true"
      [animateProgress]="true"
    ></app-progress-tracker>
    @if (
      firstLoadingFinished && migration?.status == MigrationStatus.exception
    ) {
      <div class="mat-card-extra-info">
        <mat-card appearance="outlined">
          <mat-card-header [ngClass]="migration?.status">
            <mat-card-title class="gray">Exception</mat-card-title>
          </mat-card-header>
          <mat-card-content class="error-card-content">
            <span class="error">{{ migration?.exception }}</span>
          </mat-card-content>
        </mat-card>
      </div>
    }
    @if (firstLoadingFinished && migration?.status == MigrationStatus.reject) {
      <div class="mat-card-extra-info">
        <mat-card appearance="outlined">
          <mat-card-header [ngClass]="migration?.status">
            <mat-card-title class="warning">Migration rejected</mat-card-title>
            <mat-card-subtitle
              >by
              <span class="rejectByUser">{{
                migration?.created_by
              }}</span></mat-card-subtitle
            >
          </mat-card-header>
          <mat-card-content class="error-card-content">
            <span>Reason:</span><br /><br />
            <span class="gray">{{ migration?.description }}</span>
          </mat-card-content>
        </mat-card>
      </div>
    }

    @if (firstLoadingFinished) {
      @if (entityTypes.length > 0) {
        <div class="metrics-summary-container">
          <div class="metric-item total">
            <mat-icon color="primary">storage</mat-icon>
            <span class="metric-label">Total records:</span>
            <span class="metric-value">{{ overallMetrics.totalRecords }}</span>
          </div>

          <div class="metric-item succeeded">
            <mat-icon color="success">check_circle</mat-icon>
            <span class="metric-label">Succeeded:</span>
            <span class="metric-value">{{ overallMetrics.succeeded }}</span>
          </div>

          <div class="metric-item failed">
            <mat-icon color="error">error</mat-icon>
            <span class="metric-label">Failed</span>
            <span class="metric-value">{{ overallMetrics.failed }}</span>
          </div>
          @if (
            firstLoadingFinished &&
            migration?.status === MigrationStatus.migrated_post_processing_failed
          ) {
            <div id="post-processing-failed">
              <button
                 mat-stroked-button
                color="warn"
                (click)="openPostProcessingFailedDialog()"
              >
                <mat-icon>warning</mat-icon>
                View Failed Post Processing
              </button>
            </div>
          }
        </div>
      }

      @if (migration?.remigrated_from_migration_id || migration?.remigration_data) {
        <div class="metrics-summary-container">
          <div class="metric-item total">
            <mat-icon color="primary">restart_alt</mat-icon>
            <span class="metric-label">Remigrated from migration:</span>
            <span class="metric-value">
              @if (migration?.remigrated_from_migration_id) {
                <a (click)="onRemigratedMigrationClicked(migration!.remigrated_from_migration_id!)" role="button" class="clickable-link">{{ migration!.remigrated_from_migration_id }}</a>
              } @else {
                -
              }
            </span>
          </div>

          <div class="metric-item succeeded">
            <mat-icon color="success">schema</mat-icon>
            <span class="metric-label">Selected studies:</span>
            <span class="metric-value">{{ getRemigratedProtocolsCount() }}</span>
          </div>

          <div class="metric-item total">
            <mat-icon color="primary">location_on</mat-icon>
            <span class="metric-label">Selected sites:</span>
            <span class="metric-value">{{ getRemigratedSitesCount() }}</span>
          </div>
        </div>
      }

      <div class="statistics-summary-container">
        <!-- no_of_protocols -->
        <div class="statistic-item">
          <mat-icon color="primary">play_circle</mat-icon>
          <span class="statistic-label">Studies:</span>
          <span class="statistic-value" class="primary">{{
            migration?.statistics_obj?.no_of_protocols
          }}</span>
        </div>
        <div class="statistic-item">
          <mat-icon color="success-light">play_circle</mat-icon>
          <span class="statistic-label">Started:</span>
          <span class="statistic-value" class="success">{{
            migration?.statistics_started_local
          }}</span>
        </div>
        <div class="statistic-item">
          <mat-icon color="success">task_alt</mat-icon>
          <span class="statistic-label">Ended:</span>
          <span class="statistic-value" class="success">{{
            migration?.statistics_ended_local
          }}</span>
        </div>
        <div class="statistic-item">
          <mat-icon color="primary">schedule</mat-icon>
          <span class="statistic-label">Duration:</span>
          <span class="statistic-value" class="primary">{{
            migration?.durationText || "0s"
          }}</span>
        </div>

        <div class="statistic-item">
          <a
            mat-stroked-button
            color="primary"
            [routerLink]="['/statistics']"
            [queryParams]="{ migrationId: migrationId }"
          >
            <mat-icon>bar_chart</mat-icon>
            Open statistics page
          </a>
        </div>
      </div>

      @if (entityTypes.length > 0) {
        <div class="details-tabs-container">
          <div class="details-view-toggle-container">
            <mat-slide-toggle
              [checked]="detailsViewEnabled"
              (change)="onDetailsViewToggle($event.checked)"
            >
              Details view
            </mat-slide-toggle>
          </div>
          <mat-tab-group>
            @if (!detailsViewEnabled) {
              <mat-tab label="Migration by entity type">
              <!-- <mat-expansion-panel [expanded]="true" id="migrated-entity-tab"> -->
              <mat-card id="migrated-entity-tab">
                <!-- <mat-expansion-panel-header>
                <mat-panel-title>
                  Migration metrics by entity type
                </mat-panel-title>
              </mat-expansion-panel-header> -->

                <div class="migration-metrics-container">
                  <mat-grid-list
                    [cols]="cols"
                    [rowHeight]="rowHeight"
                    gutterSize="12px"
                  >
                    <mat-grid-tile *ngFor="let entityType of entityTypes">
                      <mat-card class="metric-card compact">
                        <mat-card-header>
                          <mat-card-title class="metric-header-title-container">
                            <span class="metric-header-title">{{
                              utilsService.capitalizeFirstLetter(entityType)
                            }}</span>
                            <div class="metric-total-container">
                              <mat-icon class="chip-icon">{{
                                groupedMetrics[entityType][0].icon
                              }}</mat-icon>
                              <span class="metric-total-text"
                                >Total: {{ getTotalCount(entityType) }}</span
                              >
                            </div>
                          </mat-card-title>
                        </mat-card-header>

                        <mat-card-content>
                          <table
                            mat-table
                            [dataSource]="groupedMetrics[entityType]"
                            class="metrics-table compact"
                          >
                            <!-- Status Column -->
                            <ng-container matColumnDef="status">
                              <th mat-header-cell *matHeaderCellDef>Status</th>
                              <td
                                mat-cell
                                *matCellDef="let metric"
                                [ngClass]="metric.displayData.statusColor"
                              >
                                {{ metric.migration_status }}
                              </td>
                            </ng-container>

                            <!-- Count Column -->>

                            <!-- Count Column -->
                            <ng-container matColumnDef="count">
                              <th mat-header-cell *matHeaderCellDef>Count</th>
                              <td mat-cell *matCellDef="let metric">
                                {{ metric.count }}
                              </td>
                            </ng-container>

                            <tr
                              mat-header-row
                              *matHeaderRowDef="displayedColumns"
                            ></tr>
                            <tr
                              mat-row
                              *matRowDef="let row; columns: displayedColumns"
                            ></tr>
                          </table>
                        </mat-card-content>
                      </mat-card>
                    </mat-grid-tile>
                  </mat-grid-list>
                </div>
                <!-- </mat-expansion-panel> -->
              </mat-card>
              </mat-tab>
            }

            @if (detailsViewEnabled) {
              <mat-tab label="Migration Details by entity type">
                <mat-card id="migration-detailed-entity-tab">
                  <div class="migration-metrics-container detailed-table-container">
                    <div class="details-filter-row">
                      <mat-form-field appearance="outline" class="detailed-search-field">
                        <mat-label>Search</mat-label>
                        <input
                          matInput
                          [ngModel]="detailedSearchText"
                          (ngModelChange)="onDetailedSearchChanged($event)"
                          placeholder="Search id, name, title, email..."
                        />
                        @if (detailedSearchText) {
                          <button
                            mat-icon-button
                            matSuffix
                            aria-label="Clear search"
                            (click)="onDetailedSearchChanged('')"
                          >
                            <mat-icon>close</mat-icon>
                          </button>
                        }
                      </mat-form-field>

                      <mat-form-field appearance="outline" class="entity-type-filter-field">
                        <mat-label>Entity type</mat-label>
                        <mat-select
                          [value]="selectedDetailedEntityType"
                          panelClass="detailed-entity-select-panel"
                          (selectionChange)="onDetailedEntityTypeFilterChange($event.value)"
                        >
                          <mat-option value="all">All</mat-option>
                          @for (entityType of entityTypes; track entityType) {
                            <mat-option [value]="entityType">{{ utilsService.capitalizeFirstLetter(entityType) }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <table
                      mat-table
                      [dataSource]="detailedMetrics"
                      class="metrics-table compact detailed-metrics-table"
                      matSort
                      matSortDisableClear
                      [matSortActive]="detailedSortActive"
                      [matSortDirection]="detailedSortDirection"
                      (matSortChange)="onDetailedSortChange($event)"
                    >
                      <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                          Id
                        </th>
                        <td mat-cell *matCellDef="let metric">{{ metric.id }}</td>
                      </ng-container>

                      <ng-container matColumnDef="legacy_id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                          Legacy Id
                        </th>
                        <td mat-cell *matCellDef="let metric">
                          {{ metric.legacy_id ?? "-" }}
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                          Name
                        </th>
                        <td mat-cell *matCellDef="let metric">
                          {{ metric.name ?? "-" }}
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="title">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                          Title
                        </th>
                        <td mat-cell *matCellDef="let metric">
                          {{ metric.title ?? "-" }}
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                          Email
                        </th>
                        <td mat-cell *matCellDef="let metric">
                          {{ metric.email ?? "-" }}
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="entity_type">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                          Entity Type
                        </th>
                        <td mat-cell *matCellDef="let metric">
                          {{
                            utilsService.capitalizeFirstLetter(metric.entity_type)
                          }}
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="migration_status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                          Migration Status
                        </th>
                        <td mat-cell *matCellDef="let metric">
                          {{ metric.migration_status || "-" }}
                        </td>
                      </ng-container>

                      <tr
                        mat-header-row
                        *matHeaderRowDef="detailedMetricsDisplayedColumns"
                      ></tr>
                      <tr
                        mat-row
                        *matRowDef="let row; columns: detailedMetricsDisplayedColumns"
                      ></tr>
                    </table>

                    <mat-paginator
                      [length]="detailedTotal"
                      [pageIndex]="detailedPageIndex"
                      [pageSize]="detailedPageSize"
                      [pageSizeOptions]="[10, 25, 50, 100]"
                      (page)="onDetailedPageChange($event)"
                    ></mat-paginator>
                  </div>
                </mat-card>
              </mat-tab>
            }
          </mat-tab-group>
        </div>
      }
    }
  </mat-card-content>
  <mat-card-footer> *migration metrics </mat-card-footer>
</mat-card>
